import axios from "axios";
import { Urls } from "../../../store/urls";
import { ServiceUrls } from "../../serviceUrls";

export const postClevertapDeleteProfile = (data) => {
    return axios({
        baseURL: ServiceUrls.CLEVERTAP_DELETE_PROFILE_SERVICE,
        headers: {
            'X-CleverTap-Account-Id': '1b3-c36',
            'X-CleverTap-Passcode': 'WHS-RQD-OSEL',
            'Content-Type': 'application/json; charset=utf-8'
        },
        method: 'POST',
        url: Urls.POST_CLEVERTAP_DELETE_PROFILE,
        data: data,
    })
}

export const postLearnUserDeleteProfile = (data) => {
    return axios({
        baseURL:
            ServiceUrls.LEARN_SERVICE,
        method: "POST",
        url: Urls.POST_LEARN_USER_LOGOUT,
        data: data,
    });
};